import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'
import axios from 'axios'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../../config/api'
import Swal from 'sweetalert2'
import { FaSpinner, FaEye, FaRedoAlt, FaCheck } from 'react-icons/fa'
import { FaCcPaypal } from 'react-icons/fa6'

const PayrollHistory = () => {
    const [payrolls, setPayrolls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [processingPayrollId, setProcessingPayrollId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPayrolls = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = Cookies.get('token');
                // Using the endpoint provided in the snippet, but checking if it should be relative to API_BASE_URL
                // Since the snippet used a full URL, I will follow that but consider the project's config if it fails.
                const response = await axios.get(`${API_BASE_URL}/api/v1/payroll/runs/`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setPayrolls(response.data);
            } catch (err) {
                console.error("Error fetching payrolls:", err);
                setError('Failed to fetch payroll history.');
            } finally {
                setLoading(false);
            }
        };
        fetchPayrolls();
    }, []);

    // Helper to format date as 'Month Year' or 'Day Month Year'
    const formatMonthYear = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    };

    const formatDayMonthYear = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });
    };

    const handleRerunPayroll = async (payrollId) => {
        const result = await Swal.fire({
            title: 'Re-run Payroll?',
            text: 'This will re-process the payroll run. Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#007bff',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, re-run it',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) return;

        setProcessingPayrollId(payrollId);
        try {
            const token = Cookies.get('token');
            // Get current month in YYYY-MM-01 format
            const now = new Date();
            const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
            
            await axios.post(`${API_BASE_URL}/api/v1/payroll/runs/`, {
                month: currentMonth,
                status: "draft"
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            Swal.fire({
                title: 'Success!',
                text: 'Payroll has been re-run successfully.',
                icon: 'success',
                confirmButtonColor: '#007bff'
            });

            // Refresh the payroll list
            const response = await axios.get(`${API_BASE_URL}/api/v1/payroll/runs/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setPayrolls(response.data);
        } catch (err) {
            console.error('Error re-running payroll:', err);
            Swal.fire({
                title: 'Error!',
                text: err.response?.data?.error || 'Failed to re-run payroll. Please try again.',
                icon: 'error',
                confirmButtonColor: '#dc3545'
            });
        } finally {
            setProcessingPayrollId(null);
        }
    };

    const handleFinalizePayroll = async (payrollId) => {
        const result = await Swal.fire({
            title: 'Finalize Payroll?',
            text: 'This will finalize the payroll run. This action cannot be undone. Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, finalize it',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) return;

        setProcessingPayrollId(payrollId);
        try {
            const token = Cookies.get('token');
            await axios.patch(`${API_BASE_URL}/api/v1/payroll/runs/${payrollId}/`, {
                status: "finalized"
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            Swal.fire({
                title: 'Success!',
                text: 'Payroll has been finalized successfully.',
                icon: 'success',
                confirmButtonColor: '#28a745'
            });

            // Refresh the payroll list
            const response = await axios.get(`${API_BASE_URL}/api/v1/payroll/runs/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setPayrolls(response.data);
        } catch (err) {
            console.error('Error finalizing payroll:', err);
            Swal.fire({
                title: 'Error!',
                text: err.response?.data?.error || 'Failed to finalize payroll. Please try again.',
                icon: 'error',
                confirmButtonColor: '#dc3545'
            });
        } finally {
            setProcessingPayrollId(null);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
            <Topbar />
            <Sidebar />
            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row mb-4">
                            <div className="col-xl-12">
                                
                            </div>
                        </div>

                        <div className="row">
                            
                            <div className="col-xl-12">
                                <div className="border-0 shadow-sm">
                                <div className="p-4">
                                    <h1 className="page-title fs-24 lh-1 mb-2">Payroll History</h1>
                                    <p className="subtitle text-muted">View all processed payroll cycles</p>
                                </div>
                                    <div className="card-body p-4">
                                        {loading ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-primary mb-3" role="status"></div>
                                                <p className="text-muted fw-medium">Loading payrolls...</p>
                                            </div>
                                        ) : error ? (
                                            <div className="text-center py-5">
                                                <div className="text-danger mb-3 fs-1">{error}</div>
                                                <button className="btn btn-primary" onClick={() => window.location.reload()}>Retry</button>
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-hover align-middle mb-0">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th className="px-3 py-3 font-semibold text-dark">Payroll Month</th>
                                                            <th className="px-3 py-3 font-semibold text-dark">Processing Date</th>
                                                            <th className="px-3 py-3 font-semibold text-dark">Status</th>
                                                            <th className="px-3 py-3 font-semibold text-dark text-center">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {payrolls.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="4" className="text-center py-5 text-muted">No payroll data found.</td>
                                                            </tr>
                                                        ) : (
                                                            payrolls.map((payroll) => (
                                                                <tr key={payroll.id}>
                                                                    <td className="px-3 py-3">
                                                                        <span className="fw-bold text-dark">{formatMonthYear(payroll.month)}</span>
                                                                    </td>
                                                                    <td className="px-3 py-3 text-muted">
                                                                        {formatDayMonthYear(payroll.date_processed || payroll.created_at || payroll.month)}
                                                                    </td>
                                                                    <td className="px-3 py-3">
                                                                        <span className="fw-bold text-dark">{payroll.status}</span>
                                                                    </td>
                                                                    <td className="px-3 py-3 text-center">
                                                                        <div className="d-flex gap-2 justify-content-center">
                                                                            <button
                                                                                className="btn btn-primary btn-sm px-3 shadow-sm"
                                                                                onClick={() => navigate(`/hr/payroll/${payroll.id}/payslips`)}
                                                                            >
                                                                                <FaEye />
                                                                                View Payslips
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-warning btn-sm px-3 shadow-sm"
                                                                                onClick={() => handleRerunPayroll(payroll.id)}
                                                                                disabled={processingPayrollId === payroll.id || payroll.status !== 'draft'}
                                                                            >
                                                                                <FaRedoAlt />
                                                                                {processingPayrollId === payroll.id ? 'Processing...' : 'Re-run'}
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-success btn-sm px-3 shadow-sm"
                                                                                onClick={() => handleFinalizePayroll(payroll.id)}
                                                                                disabled={processingPayrollId === payroll.id || payroll.status !== 'draft'}
                                                                            >
                                                                                <FaCheck />
                                                                                {processingPayrollId === payroll.id ? 'Processing...' : 'Finalize'}
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default PayrollHistory